import { Module } from "@/constants";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";
import { ProjectPeriodConfirmationService } from "@/modules/projects/service/projectPeriodConfirmation";
import type { CreateProjectPeriodConfirmation } from "@/types/projectPeriodConfirmation";
import { ApiError } from "@/services/api";
import { useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/components/ui/use-toast";
import { useTranslation } from "react-i18next";

export const useCreateProjectPeriodConfirmation = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation();

  return useMutationWithErrorHandling<
    unknown,
    ApiError,
    CreateProjectPeriodConfirmation,
    unknown
  >({
    mutationFn: ProjectPeriodConfirmationService.create,
    onSuccess: (_data, variables) => {
      toast({
        title: t("projectPeriodConfirmation.success"),
      });
      queryClient.invalidateQueries({
        queryKey: [
          Module.ProjectPeriodConfirmations,
          variables.project_id,
          variables.period,
          "status",
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [Module.Projects, variables.project_id],
      });
      queryClient.invalidateQueries({ queryKey: [Module.Projects] });
    },
    errorTitle: t("projectPeriodConfirmation.errors.create"),
  });
};
